import {
  ReconciliationOutlined,
  FieldTimeOutlined,
  SwapOutlined,
  CaretDownOutlined,
  DashboardOutlined,
  ArrowLeftOutlined,
  ArrowDownOutlined,
  DownOutlined,
  EditOutlined,
  CloseOutlined,
  CheckOutlined,
  DeleteOutlined,InfoCircleOutlined
} from "@ant-design/icons";
import { Space, Slider, Input, Tag, Dropdown,Tooltip as tooltip } from "antd";
import axios from "axios";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  createRef,
} from "react";
import { DatePicker } from "antd";
import moment from "moment";
import { get, post } from "../Libraries/Ajax/HttpService";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
// import { RangeStepInput } from "react-range-step-input";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  LineChart,
  Legend,
  Tooltip,
  Line,
  Label,
  Bar,
  BarChart,
  ResponsiveContainer,
} from "recharts";
import { Spin } from "antd";
// import Examples from "./multipleselectDropdownagg";
import { CSVLink } from "react-csv";
// import * as htmlToImage from "html-to-image";
import * as htmlToImage from "dom-to-image-more";
import { toast } from "react-toastify";
import back from "../assets/images/back.svg";
import download from "../assets/images/download.svg";
import deleteIcon from "../assets/images/delete.svg";
import edit from "../assets/images/edit.svg";
// import dayjs from "../utils/dayjsConfig";
import { makeDisabledDatePastNDays } from "../utils/dateLimits";
import { useDistrict } from "../utils/DistrictContext";
import ExamplesWithDistrict from "./multipleselectDropdownagg";

function WaterAgg() {
  const { RangePicker } = DatePicker;
  const dateFormat = "YYYY/MM/DD";
  const weekFormat = "MM/DD";
  const [show, setshow] = useState(false);
  const domEl = useRef(null);
  const [first, setfirst] = useState(false);
  const [toggle, setToggle] = useState(false);

  const [defaultOption, setDefaultOption] = useState("Past Month");
  const [defaultOptionss, setDefaultOptionss] = useState("Category");
  const [defaultCategory, setDefaultCategory] = useState("industrial");
  const { Option } = Select;
  const [parameterthree, setParameterthree] = useState(null);
  const [callData, setcallData] = useState([]);
  const [response, setResponse] = useState([]);
  const [color, setColor] = useState([]);
  const [merge, setMerge] = useState([null]);
  const [nerge, setNerge] = useState([null]);
  const [aggregateData, setAggregateData] = useState([]);
  const [aggregateDatas, setAggregateDatas] = useState([]);
  const [nerges, setNerges] = useState([null]);
  const [mergenew, setMergenew] = useState([null]);
  const [test, setTest] = useState([]);

  const arryDatas = [];
  const arryDatass = [];
  const arryDatasstwo = [];
  const arryDatassnew = [];
  const users = [];
  const [parameterone, setParameterone] = useState(null);
  const [parametertwo, setParametertwo] = useState(null);
  const [optionone, setOptionone] = useState(["Weekday"]);
  const [optiononenew, setOptiononenew] = useState(["Day"]);
  const [myDatas, setmyDatas] = useState([]);
  const [myData, setmyData] = useState([]);
  const [mySample, setmySample] = useState([]);
  const [myAggregate, setmyAggregate] = useState([]);
  const [myAggregatedummy, setmyAggregatedummy] = useState([]);
  const [slvalue, setSlvalue] = useState(1);
  const [value, setvalue] = useState(1);
  const [slmax, setSlmax] = useState(4);
  const [count, setCount] = useState(0);
  const [messagecount, setMessagecount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [listOfUsers, setListofUsers] = useState([]);
  const [listOfUserss, setListofUserss] = useState([]);
  const [listOfCategory, setListofCategory] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [previousResLength, setPreviousResLength] = useState(0);
  const [water, setWater] = useState(false);
  const [wateragg, setWateragg] = useState(true);
  const [showInputs, setShowInputs] = useState(Array(10).fill(true)); // Assuming 10 inputs, change the number as needed
  const [inputValues, setInputValues] = useState(Array(10).fill(""));
  const selectedDistrict = useDistrict();
  const disabledDate = makeDisabledDatePastNDays(2);

  useEffect(() => {
    if (
      defaultOption === "Past Month" ||
      defaultOption === "Past 3 Months" ||
      defaultOption === "Past Year"
    ) {
      setOptiononenew("Week");
    }
  }, [defaultOption]);

  const domEls = useRef([]);
  const onClickContent = (index) => {
    const updatedInputs = [...showInputs];
    updatedInputs[index] = !updatedInputs[index]; // Toggle the state of the clicked input field
    setShowInputs(updatedInputs);
  };
  // const valueArray = [];
  const onClickValue = (index) => {
    const updatedInputss = [...showInputs];
    updatedInputss[index] = !updatedInputss[index];
    setShowInputs(updatedInputss);
  };

  const onClickClose = (index) => {
    const updatedInputs = [...showInputs];
    updatedInputs[index] = true; // Show the previous view
    setShowInputs(updatedInputs);

    // Reset the input value to empty string
    const newInputValues = [...inputValues];
    newInputValues[index] = "";
    setInputValues(newInputValues);
  };
  const onselectClicks = () => {
    // setName('Accountability');
    setWater(true);
    setWateragg(false);
    navigate("/Waters");
  };
  const onselectClickss = () => {
    // setName('Accountability');
    setWater(false);
    setWateragg(true);
    navigate("/Wateragg");
  };
  const onChangeToWaterMeterReading = () => {
    navigate("/watermeterreadings");
  };

  // const disabledDate = (current) => {
  //   if (!current) return false;

  //   const now = dayjs();  // already defaults to US/Central
  //   const cutoffDay = now.subtract(2, "day").startOf("day");

  //   return current.isAfter(cutoffDay, "day") || current.isSame(cutoffDay, "day");
  // };

  // useEffect(() => {
  //     const isMizuWatch = window.location.href.includes("mizuwatch.com");
  //     document.title = isMizuWatch ? "MizuWatch" : "MizuSmart";
  //   }, []);

  const handleInputChange = (event, index) => {
    const newInputValues = [...inputValues];
    newInputValues[index] = event.target.value;
    setInputValues(newInputValues);
  };
  //
  const inputRef = useRef(null);
  const controller = new AbortController();
  const signal = controller.signal;
  const customFormat = (value) => `custom format: ${value.format(dateFormat)}`;
  const navigate = useNavigate();
  const incrementCount = () => {
    // Update state with incremented value
    setCount(count + 1);
  };

  // const downloadImage = async (code, index) => {
  //   if (myData.length > 0) {
  //     const dataUrl = await htmlToImage.toPng(domEls.current[index]);

  //     // download image
  //     const link = document.createElement("a");
  //     link.download = code.toString();
  //     link.href = dataUrl;
  //     link.click();
  //   } else {
  //     toast.info("Please select account before download");
  //   }
  // };
  // const downloadImages = async () => {
  //   if (myData.length > 0) {
  //     const dataUrl = await htmlToImage.toPng(domEl.current);

  //     // download image
  //     const link = document.createElement("a");
  //     link.download = optiononenew.toString() + "-" + defaultOption.toString();
  //     link.href = dataUrl;
  //     link.click();
  //   } else {
  //     toast.info("Please select account before download");
  //   }
  // };
  const downloadImage = async (code, index) => {
    const el = domEls.current?.[index];

    if (!el) {
      toast.error("Element not found");
      return;
    }

    // Ensure layout is measured correctly
    const rect = el.getBoundingClientRect();
    const width = Math.ceil(rect.width);
    const height = Math.ceil(rect.height);

    try {
      const dataUrl = await htmlToImage.toPng(el, {
        width,
        height,
        style: {
          width: `${width}px`,
          height: `${height}px`,
          overflow: "visible",
          transform: "none",
        },
        cacheBust: true,
        backgroundColor: "white",
      });

      // Trigger image download
      const link = document.createElement("a");
      link.download =
        code +
        "-" +
        JSON.parse(localStorage.getItem("MCData"))
          ?.selectedDistrict?.toString()
          .toString();
      link.href = dataUrl;
      document.body.appendChild(link); // Needed for Firefox
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Image generation failed:", err);
      toast.error("Failed to download image.");
    }
  };
  const downloadImages = async () => {
    if (!myData || myData.length === 0) {
      toast.info("Please select account before download");
      return;
    }

    const node = domEl.current;
    if (!node) {
      toast.error("Export target not found");
      return;
    }

    // Calculate bounding box size
    const rect = node.getBoundingClientRect();
    const width = Math.ceil(rect.width);
    const height = Math.ceil(rect.height);

    try {
      const dataUrl = await htmlToImage.toPng(node, {
        width,
        height,
        style: {
          width: `${width}px`,
          height: `${height}px`,
          transform: "none",
          overflow: "visible",
        },
        cacheBust: true,
        backgroundColor: "white",
      });

      const link = document.createElement("a");
      link.download = `${optiononenew}-${defaultOption}-${JSON.parse(
        localStorage.getItem("MCData")
      )?.selectedDistrict?.toString()}.png`;
      link.href = dataUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Image export failed:", error);
      toast.error("Could not download image");
    }
  };
  const onchanges = (value, dateString) => {
    setParameterthree(dateString);
  };
  const onRedirection = (event) => {
    navigate(-1);
  };

  const add = (name, code) => (e) => {
    let Obj = {
      name: name,
      code: code,
    };
    let sample = [...myAggregate]; // Create a copy of myAggregate

    // if(previousResLength.length<5){
    if (sample.some((item) => item.name === name && item.code === code)) {
      // e.target.classList.add('nohighlight');
      //  e.target.classList.remove('highlight');
      sample = sample.filter(
        (item) => !(item.name === name && item.code === code)
      );

      setmyAggregate(sample);
      const resultObj = {};

      sample.forEach((item) => {
        const code = item.code;
        const name = item.name;

        if (!resultObj[code]) {
          resultObj[code] = { code, accounts: [] };
        }

        if (!resultObj[code].accounts.includes(name)) {
          resultObj[code].accounts.push(name);
        }
      });

      const resultArray = Object.values(resultObj);
      const sortedDatas = resultArray
        .slice()
        .sort((a, b) => a.code.localeCompare(b.code));
      setmyDatas(sortedDatas);
    } else {
      myAggregate.push(Obj);
      const resultObj = {};

      myAggregate.forEach((item) => {
        const code = item.code;
        const name = item.name;

        if (!resultObj[code]) {
          resultObj[code] = { code, accounts: [] };
        }

        if (!resultObj[code].accounts.includes(name)) {
          resultObj[code].accounts.push(name);
        }
      });

      const resultArray = Object.values(resultObj);
      const sortedDatas = resultArray
        .slice()
        .sort((a, b) => a.code.localeCompare(b.code));
      setmyDatas(sortedDatas);
    }

    const transformedData = {};

    myAggregate.forEach((item) => {
      if (!transformedData[item.name]) {
        transformedData[item.name] = { name: item.name, code: [item.code] };
      } else {
        transformedData[item.name].code.push(item.code);
      }
    });

    const result = Object.values(transformedData);
    setmyAggregatedummy(result);
  };
  const adds = (name) => (e) => {
    const decodedName = decodeURIComponent(name);

    // if(previousResLength.length<5){
    if (myData?.some((item) => decodeURIComponent(item) === decodedName)) {
      const newArray = myData?.filter(
        (item) => decodeURIComponent(item) !== decodedName
      );
      setmyData(newArray);
    } else {
      if (name == "Whataburger #1081") {
        setmyData([...myData, "Whataburger%20%231081"]);
      } else {
        setmyData([...myData, name]);
      }
    }
  };
  const handleToggleChange = () => {
    setIsChecked(!isChecked);
  };

  // const onchange = (value, dateString) => {
  //   setParameterone(dateString[0]);
  //   setParametertwo(dateString[1]);
  //   var diff =
  //     (new Date(parametertwo) - new Date(parameterone)) /
  //     (1000 * 60 * 60 * 24) /
  //     7 /
  //     2;
  //   setvalue(
  //     Math.floor(
  //       (new Date(parametertwo) - new Date(parameterone)) /
  //         (1000 * 60 * 60 * 24) /
  //         7
  //     )
  //   );

  //   setSlmax(diff);
  // };

  const onchange = (value, dateString) => {
    const start = dateString[0];
    const end = dateString[1];

    setParameterone(start);
    setParametertwo(end);

    const diffDays = (new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24);

    // ---------------------------
    // Auto-select interval based on Custom range
    // ---------------------------
    if (defaultOption === "Custom") {
      if (diffDays > 7) {
        setOptiononenew("Week"); // More than a week → Week
      } else {
        setOptiononenew("Day"); // 7 days or less → Day
      }
    }

    // ---------------------------
    // Your existing logic
    // ---------------------------
    const diff =
      (new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24) / 7 / 2;

    setvalue(
      Math.floor((new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24) / 7)
    );

    setSlmax(diff);
  };

  const onSelects = (event) => {
    if (event == "account") setDefaultOptionss("Account");
    else if (event == "category") setDefaultOptionss("Category");
  };
  const onSelectCategory = (event) => {
    setDefaultCategory(event);
  };
  const sliderChange = (event) => {
    setSlvalue(event.target.value);
  };
  const onMouseClick = (event) => {
    setSlvalue(1);
    setDefaultOption(event.target.value);
    if (event.target.value == "Past Day") {
      setOptiononenew("Hour");
    } else if (
      event.target.value == "Past Year" ||
      event.target.value == "Past Month" ||
      event.target.value == "Past 3 Months" ||
      event.target.value == "Custom"
    ) {
      setOptiononenew("Day");
    } else if (event.target.value == "Past Week") {
      setOptiononenew("Day");
    }
    // else if(defaultOption=="Past 3 Months")
    // {
    //     setSlmax(6);
    // }
  };
  const radioChanges = (event) => {
    setOptionone(event.target.id);
  };
  const radioChange = (event) => {
    event.stopPropagation();
    setSlvalue(1);
    setOptiononenew(event.target.id);
  };

  const itemss = [
    {
      label: (
        <a href="#" onClick={downloadImages}>
          Download As PNG
        </a>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <button className="csvlink">
          <CSVLink
            data={listOfUserss}
            filename={
              optiononenew.toString() +
              "-" +
              defaultOption.toString() +
              "-" +
              JSON.parse(
                localStorage.getItem("MCData")
              )?.selectedDistrict?.toString()
            }
          >
            Download As CSV
          </CSVLink>
        </button>
      ),

      key: "1",
    },
  ];

  const dailyClick = () => {
    setToggle(false);
  };
  function isConditionMet(overideAccName, code) {
    return myAggregatedummy.some(
      (item) => item.name === overideAccName && item.code.includes(code)
    );
  }
  const hourlyClick = () => {
    setToggle(true);
  };
  const customWeekStartEndFormat = (value) =>
    `${moment(value).startOf("week").format(weekFormat)} ~ ${moment(value)
      .endOf("week")
      .format(weekFormat)}`;

  const handleMenuClick = (e) => {
    if (e.key == 2) {
    }
  };
  const HandleMenuClicks = (e) => {
    if (e.key == 6) {
      setshow(true);
    } else {
      setshow(false);
    }
  };
  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    get(`apis/user_color?user_id=${userid}`).then((response) => {
      setColor(response.data.color);
    });
  }, [selectedDistrict]);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    let arryDatas = [];

    setLoading(true);

    const paramsDatas = myDatas.map((item) => ({ ...item }));
    const paramsAggregate = myAggregate?.map((item) => ({ ...item }));

    const isCustom = defaultOption === "Custom";
    const hasData = myData.length > 0;

    // ------------------------------
    // CASE A: Custom + Category (POST)
    // ------------------------------
    if (isCustom && hasData && isChecked && parameterone && parametertwo) {
      post(
        `apis/water/aggregate/category?option=${optiononenew}&start=${parameterone}&end=${parametertwo}&range_option=${defaultOption}&interval=${slvalue}`,
        paramsDatas
      )
        .then((response) => {
          setListofUsers(response.data.data.water_flow);

          const aggregatedData = response?.data?.data?.water_flow;

          myDatas.forEach((item, index) => {
            const convertedData = Object.keys(aggregatedData).map((code) => {
              return aggregatedData[code].flatMap((arr) => {
                const option = arr[0].flow_date_check;
                const resultObj = {
                  code,
                  code_name: arr[0].option,
                  option,
                };

                arr.forEach((obj) => {
                  resultObj[obj.overided_name] = obj.flow;
                });

                return resultObj;
              });
            });

            arryDatas.push(convertedData);
          });

          setAggregateDatas(arryDatas);
        })
        .catch(() => {});

      return () => controller.abort();
    }

    // ------------------------------
    // CASE B: Custom + Account (GET)
    // ------------------------------
    if (isCustom && hasData && !isChecked && parameterone && parametertwo) {
      get(
        `apis/water/aggregate/account?option=${optiononenew}&start=${parameterone}&end=${parametertwo}&range_option=${defaultOption}&interval=${slvalue}&selected=${JSON.stringify(
          myData
        )}`,
        { signal }
      )
        .then((response) => {
          const aggregatedData = response?.data?.data?.water_flow;

          aggregatedData.forEach((item) => {
            let name = item[0]?.flow_date_check;
            let names = item[0]?.option;
            let month = item[0]?.option_month;

            const meterData = Object.fromEntries(
              item.map(({ overided_name, flow }) => [overided_name, flow])
            );

            const weeklyMeterData = { name, names, month, ...meterData };
            arryDatas.push(weeklyMeterData);

            setTimeout(() => {
              setAggregateData(arryDatas);
            }, 1000);
          });

          setLoading(false);
        })
        .catch(() => setLoading(false));

      return () => controller.abort();
    }

    // ------------------------------
    // CASE C: Non-Custom + Category (POST)
    // ------------------------------
    if (!isCustom && hasData && isChecked) {
      post(
        `apis/water/aggregate/category?option=${optiononenew}&range_option=${defaultOption}&interval=${slvalue}`,
        paramsDatas
      )
        .then((response) => {
          const aggregatedData = response?.data?.data?.water_flow;

          myDatas.forEach((item, index) => {
            const convertedData = Object.keys(aggregatedData).map((code) => {
              return aggregatedData[code].flatMap((arr) => {
                const option = arr[0].flow_date_check;

                const resultObj = {
                  code,
                  code_name: arr[0].option,
                  option,
                };

                arr.forEach((obj) => {
                  resultObj[obj.overided_name] = obj.flow;
                });

                return resultObj;
              });
            });

            arryDatas.push(convertedData);
          });

          setAggregateDatas(arryDatas);
        })
        .catch(() => {});

      return () => controller.abort();
    }

    // ------------------------------
    // CASE D: Non-Custom + Account (GET)
    // ------------------------------
    if (!isCustom && hasData && !isChecked) {
      get(
        `apis/water/aggregate/account?option=${optiononenew}&range_option=${defaultOption}&interval=${slvalue}&selected=${JSON.stringify(
          myData
        )}`,
        { signal }
      )
        .then((response) => {
          setListofUserss(response?.data?.data?.download_water_flow);

          const aggregatedData = response?.data?.data?.water_flow;

          aggregatedData.forEach((item) => {
            let name = item[0]?.flow_date_check;
            let names = item[0]?.option;
            let month = item[0]?.option_month;

            const meterData = Object.fromEntries(
              item.map(({ overided_name, flow }) => [overided_name, flow])
            );

            const weeklyMeterData = { name, names, month, ...meterData };

            arryDatas.push(weeklyMeterData);

            setTimeout(() => {
              setAggregateData(arryDatas);
            }, 1000);
          });

          setLoading(false);
        })
        .catch(() => setLoading(false));

      return () => controller.abort();
    }

    // ------------------------------
    // Clean up on any exit
    // ------------------------------
    return () => controller.abort();
  }, [
    optiononenew,
    slvalue,
    defaultOption,
    myData,
    myDatas,
    myAggregate,
    parameterone,
    parametertwo,
    isChecked,
    selectedDistrict,
  ]);

  useEffect(() => {
    setLoading(true);
    if (defaultOption == "Custom" && myDatas.length > 0 && isChecked) {
      const params = myDatas.map((item) => ({ ...item }));
      post(
        `apis/download/water/aggregate/category?option=${optiononenew}&start=${parameterone}&end=${parametertwo}&range_option=${defaultOption}&interval=${slvalue}`,
        params[0]
      ).then((response) => {
        setListofUsers(response?.data?.data?.water_flow);
      });
    }
  }, [
    myDatas,
    parameterone,
    parametertwo,
    optiononenew,
    slvalue,
    defaultOption,
    isChecked,
    selectedDistrict,
  ]);

  useEffect(() => {
    setLoading(true);
    if (defaultOption !== "Custom" && myDatas.length > 0 && isChecked) {
      const apiPromises = myDatas.map((item, index) => {
        const params = { ...item };

        return post(
          `apis/download/water/aggregate/category?option=${optiononenew}&range_option=${defaultOption}&interval=${slvalue}`,
          params
        ).then((response) => response?.data?.data?.water_flow);
      });

      Promise.all(apiPromises)
        .then((fulfilledValues) => {
          fulfilledValues.forEach((arrayOfValues) => {
            users.push(arrayOfValues);
          });
          setListofUsers(users);
        })
        .catch((error) => {});
    }
  }, [
    myDatas,
    optiononenew,
    slvalue,
    defaultOption,
    isChecked,
    selectedDistrict,
  ]);

  useEffect(() => {}, [isChecked, selectedDistrict]);

  const handleCallback = (childData, res) => {
    setcallData(childData.data.data.categories.selected_categories);

    const products = [];
    const productmysample = [];
    const myaggregates = [];
    const myaggregatess = [];
    if (res && res.length > 0) {
      if (res.length === previousResLength + 1) {
        const lastCode = res[res.length - 1];

        const additionalData =
          childData?.data?.data?.categories?.selected_categories?.find(
            (item) => {
              return item.Overide_acc_name === decodeURIComponent(lastCode);
            }
          );

        additionalData?.category.forEach((categoryItem) => {
          const formattedItem = {
            name: categoryItem.overided_name,
            code: categoryItem.code,
          };
          myaggregatess.push(formattedItem);
        });
        const mergedArray = [...myAggregate, ...myaggregatess];
        setmyAggregate(mergedArray);
        const resultObj = {};
        mergedArray.forEach((item) => {
          const code = item.code;
          const name = item.name;

          if (!resultObj[code]) {
            resultObj[code] = { code, accounts: [] };
          }

          if (!resultObj[code].accounts.includes(name)) {
            resultObj[code].accounts.push(name);
          }
        });

        const resultArray = Object.values(resultObj);

        const sortedDatas = resultArray
          .slice()
          .sort((a, b) => a.code.localeCompare(b.code));
        setmyDatas(sortedDatas);

        setPreviousResLength(res?.length);
      } else {
        setPreviousResLength(res?.length);
        childData.data.data.categories.selected_categories.forEach((item) => {
          const overided_name = item.Overide_acc_name;

          item.category.forEach((categoryItem) => {
            const formattedItem = {
              name: overided_name,
              code: categoryItem.code,
            };
            myaggregates.push(formattedItem);
          });
        });
        const uniqueNames = Array.from(
          new Set(myaggregates.map((item) => item.name))
        );
        const filteredArray = myAggregate.filter((item) =>
          uniqueNames.includes(item.name)
        );

        setmyAggregate(filteredArray);

        const resultObj = {};
        filteredArray.forEach((item) => {
          const code = item.code;
          const name = item.name;

          if (!resultObj[code]) {
            resultObj[code] = { code, accounts: [] };
          }

          if (!resultObj[code].accounts.includes(name)) {
            resultObj[code].accounts.push(name);
          }
        });

        const resultArray = Object.values(resultObj);

        const sortedDatas = resultArray
          .slice()
          .sort((a, b) => a.code.localeCompare(b.code));
        setmyDatas(sortedDatas);
      }
    }
    setResponse(res);
    if (res?.length > 0) {
      setmyData(res);
    }
    if (childData.data.data.categories.selected_categories.length == 0) {
      setmyData([]);
      setmyAggregate([]);
      setmyDatas([]);
      setPreviousResLength(0);
    }
  };
  return (
    <>
      {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div className="waterDetails">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <img
                src={back}
                alt=""
                style={{ width: "10px", cursor: "pointer" }}
                onClick={onRedirection}
              />

              <div className="d-flex align-items-center">
                <div
                  className="new-box-padding   align-self-center c-pointer  "
                  onClick={onselectClicks}
                  style={{
                    borderBottom: "2px solid #ccc",
                  }}
                >
                  Water Usage<tooltip title="Shows water consumption per meter for the selected date range. Compare usage of up to 8 meters at once.">
                    <InfoCircleOutlined
                      className="ms-1 text-blue"
                      style={{ fontSize: "14px" }}
                    />
                  </tooltip>
                </div>
                <div
                  className=""
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>
                <div
                  className="new-box-padding  text-blue  align-self-center c-pointer"
                  onClick={onselectClickss}
                  style={{
                    borderBottom: "2px solid #1998f0",
                    borderRadius: "0",
                  }}
                >
                  Aggregate Usage<tooltip title="Shows total water consumption per account for the selected date range. Use the category toggle to view usage by meter category within each account.">
                    <InfoCircleOutlined
                      className="ms-1 text-blue"
                      style={{ fontSize: "14px" }}
                    />
                  </tooltip>
                </div>
                <div
                  className=""
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>
                <div
                  className="new-box-padding   align-self-center c-pointer"
                  onClick={onChangeToWaterMeterReading}
                  style={{
                    borderBottom: "2px solid #ccc",
                  }}
                >
                  Meters By Flow<tooltip title="Lists meters in descending order of total flow for the selected date range and preselected meter categories. View water consumption trends over the selected period.">
                    <InfoCircleOutlined
                      className="ms-1 text-blue"
                      style={{ fontSize: "14px" }}
                    />
                  </tooltip>
                </div>
              </div>
            </div>
          </div>
          <div className="row row-cols-4 g-3 align-items-end w-100 mt-2">
            <div className="col-12 col-lg-3 ps-0">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <h3
                  className="my-0"
                  style={{
                    margin: "0rem",
                    padding: "0.25rem 0.5em",

                    // border: '1px solid #D9D9D9',

                    fontSize: "fs-26",
                    // width: '400px',
                    color: "#1998f0",
                    height: "50px",
                  }}
                >
                  {" "}
                  Accounts
                </h3>

                <div
                  className="form-check form-switch"
                  style={{ paddingLeft: "3.5em" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                    checked={isChecked}
                    onChange={handleToggleChange}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexSwitchCheckDefault"
                  >
                    Category
                  </label>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-3 mt-0 multiselectDropdownStyle">
              {/* <div className="col-12 col-lg-3 multiselectDropdownStyle mt-0"> */}
              <div className="w-100 text-blue">Accounts</div>
              {/* <Examples parentCallback={handleCallback} elementValue={myData} /> */}
              <ExamplesWithDistrict
                parentCallback={handleCallback}
                elementValue={myData}
                key={selectedDistrict?.selectedDistrict}
                selectedDistrict={selectedDistrict?.selectedDistrict}
              />
              {/* </div> */}
            </div>

            <div className="col-12 col-lg-3 mt-0">
              <div className="w-100 text-blue">Date Range</div>
              <div
                id="1st"
                className="w-100 d-flex selectCalender ms-auto mt-0 water-space align-items-center
                            justify-content-center"
              >
                <div className="d-flex w-100">
                  <div className="fs-26 fw-bold d-flex w-100 water">
                    <select
                      name="All meters"
                      id="selector"
                      className="box"
                      onChange={onMouseClick}
                    >
                      <option value="Past Year">Past 365 Days</option>
                      <option value="Past 3 Months">Past 90 Days </option>
                      <option value="Past Month" selected>
                        Past 30 Days
                      </option>
                      <option value="Past Week">Past 7 Days</option>
                      <option value="Past Day">Past Day</option>
                      <option value="Custom">Custom</option>
                    </select>
                  </div>
                  <Space
                    direction="horizontal"
                    size={1}
                    className="custom-date"
                  >
                    {defaultOption === "Custom" ? (
                      <RangePicker
                        onChange={onchange}
                        disabledDate={disabledDate}
                        separator={<SwapOutlined />}
                      />
                    ) : (
                      ""
                    )}
                  </Space>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-2 mt-0">
              <div className="w-100 text-blue">Interval</div>
              <div className="dropdown intervaldropdown">
                <button
                  className="btn w-100 text-left-content d-flex justify-content-between align-items-center"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {optiononenew === "Month"
                    ? optiononenew
                    : slvalue + " " + optiononenew}
                  <span className="d-block" style={{ lineHeight: "0" }}>
                    {" "}
                    <CaretDownOutlined />{" "}
                  </span>
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <li className="interdrop">
                    {defaultOption == "Past Week" ? (
                      <>
                        <div class="form-check d-flex align-items-center">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="Day"
                            onClick={radioChange}
                            defaultChecked="true"
                          />
                          <label
                            className="form-check-label"
                            for="Day"
                            onClick={radioChange}
                          >
                            Days
                          </label>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {defaultOption == "Past Day" ? (
                      <>
                        <div class="form-check d-flex align-items-center">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="Hour"
                            onClick={radioChange}
                            defaultChecked="true"
                          />
                          <label
                            className="form-check-label"
                            for="Hour"
                            onClick={radioChange}
                          >
                            Hours
                          </label>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {defaultOption == "Past 3 Months" ||
                    defaultOption == "Past Month" ? (
                      <>
                        <div class="form-check d-flex align-items-center">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="Day"
                            onClick={radioChange}
                            // defaultChecked="true"
                          />
                          <label
                            className="form-check-label"
                            for="Day"
                            onClick={radioChange}
                          >
                            Days
                          </label>
                        </div>
                        <div class="form-check d-flex align-items-center">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="Week"
                            onClick={radioChange}
                            checked={optiononenew === "Week"}
                            defaultChecked="true"
                          />
                          <label
                            className="form-check-label"
                            for="Week"
                            onClick={radioChange}
                          >
                            Weeks
                          </label>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {defaultOption === "Past Year" ||
                    defaultOption == "Custom" ? (
                      <>
                        <div class="form-check d-flex align-items-center">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="Day"
                            onClick={radioChange}
                            defaultChecked="true"
                          />
                          <label
                            className="form-check-label"
                            for="Day"
                            onClick={radioChange}
                          >
                            Days
                          </label>
                        </div>
                        <div class="form-check d-flex align-items-center">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="Week"
                            onClick={radioChange}
                          />
                          <label
                            className="form-check-label"
                            for="Week"
                            onClick={radioChange}
                          >
                            Weeks
                          </label>
                        </div>
                        {defaultOption === "Past Year" ||
                        (defaultOption === "Custom" &&
                          (new Date(parametertwo) - new Date(parameterone)) /
                            (1000 * 60 * 60 * 24) >
                            179) ? (
                          <div class="form-check d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Month"
                              onClick={radioChange}
                              defaultChecked="true"
                              checked={optiononenew === "Month"}
                            />
                            <label
                              className="form-check-label"
                              for="Month"
                              onClick={radioChange}
                            >
                              Months
                            </label>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </li>

                  {optiononenew !== "Month" ? (
                    <li
                      className="interdrop"
                      style={{ borderTop: "1px solid #ccc" }}
                    >
                      <div className="d-flex w-100 mt-2 align-items-center justify-content-between">
                        <label className="me-4">Range</label>
                        <div className="fs-26 fw-bold d-flex w-50 water">
                          {optiononenew === "Week" ? (
                            <select
                              name="All meters"
                              id="selector"
                              className="box"
                              onChange={sliderChange}
                              style={{ border: "1px solid #ccc" }}
                            >
                              <option value="1" selected>
                                1
                              </option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                            </select>
                          ) : (
                            <select
                              name="All meters"
                              id="selector"
                              className="box"
                              onChange={sliderChange}
                              style={{ border: "1px solid #ccc" }}
                            >
                              <option value="1" selected>
                                1
                              </option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                            </select>
                          )}
                        </div>
                      </div>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            </div>

            <div className="col-12 col-lg-1 mt-0">
              {!isChecked ? (
                <div className="ml-auto downloads float-right">
                  {!isChecked && (
                    <Dropdown
                      getPopupContainer={(trigger) => trigger.parentNode}
                      menu={{
                        items: itemss,
                      }}
                      trigger={["click"]}
                      className="me-0 px-3 mb-0"
                    >
                      {/* Wrap the content in a single element */}
                      <div>
                        <a onClick={(e) => e.preventDefault()}>
                          <Space>
                            <img
                              src={download}
                              alt="download"
                              style={{ width: "25px" }}
                              title="Download"
                            />
                            {/* Download   <CaretDownOutlined /> */}
                          </Space>
                        </a>
                      </div>
                    </Dropdown>
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div className="row me-0 pt-4 h-100">
          <div className="col-12 col-lg-3 water-100">
            {/* show category */}
            {isChecked ? (
              <>
                <div className="water-accountLists rounded pt-2 pe-0 bg-white h-100">
                  {callData?.map((persons, indexs) => (
                    <div key={indexs}>
                      <div>
                        <ul className="p-3 pt-4 mb-0">
                          <h5 class="py-2 non-agg-heading">
                            {persons.Overide_acc_name}
                          </h5>
                          {persons.category.map((person, indexss) => {
                            return (
                              <li
                                key={indexss}
                                className={`d-flex align-items-center gap-3 mb-2 non-agg-heading-list ${
                                  myDatas.some(
                                    (data) =>
                                      data.code === person.code &&
                                      data.accounts.includes(
                                        persons.Overide_acc_name
                                      )
                                  )
                                    ? "highlight"
                                    : "nohighlight"
                                }`}
                                onClick={add(
                                  persons.Overide_acc_name,
                                  person.code
                                )}
                              >
                                {person.code_name}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="water-accountListsnew rounded pt-2 pe-0 bg-white h-100">
                  {callData?.map((person, indexs) => (
                    <div key={indexs}>
                      <ul className="padding-aggregate mt-3">
                        {decodeURIComponent(myData)?.includes(
                          person.Overide_acc_name
                        ) ? (
                          <li
                            style={{
                              backgroundColor: "#f1f9ff",
                              color: "#1998f0",
                            }}
                            onClick={adds(person.Overide_acc_name)}
                          >
                            {" "}
                            <h5 className="d-flex align-items-center gap-3 list-heading">
                              {person.Overide_acc_name}
                            </h5>
                          </li>
                        ) : (
                          <li
                            onClick={adds(person.Overide_acc_name)}
                            style={{ backgroundColor: "white", color: "#000" }}
                          >
                            <h5 className="d-flex align-items-center gap-3 list-heading">
                              {person.Overide_acc_name}
                            </h5>
                          </li>
                        )}
                      </ul>
                    </div>
                  ))}
                </div>
              </>
            )}
            {/*  */}
          </div>
          {/* </div> */}
          {!isChecked && !loading ? (
            <div
              className="col-12 col-lg-9 water-chartLists water-graphs bg-white"
              id="domEl"
              ref={domEl}
            >
              <div className=" pt-4 h-100">
                <div
                  style={{
                    maxWidth: "100%",
                    margin: "0 auto",
                    height: "500px",
                  }}
                  className="line-chart"
                >
                  {Array.isArray(aggregateData) &&
                  aggregateData.length > 0 &&
                  myData?.length > 0 ? (
                    <ResponsiveContainer width="100%" height={500}>
                      <LineChart
                        key={JSON.stringify(myData)}
                        data={aggregateData}
                        margin={{ top: 5, right: 50, left: 20, bottom: 5 }}
                      >
                        <XAxis
                          xAxisId="0"
                          dataKey="name"
                          tick={false}
                          angle={-45}
                          textAnchor="end"
                        />
                        {defaultOption !== "Past Year" && value <= 10 && (
                          <XAxis
                            dataKey="names"
                            allowDuplicatedCategory={false}
                            xAxisId="1"
                          />
                        )}
                        <XAxis
                          dataKey="month"
                          allowDuplicatedCategory={false}
                          xAxisId="2"
                        />
                        <YAxis tickFormatter={(v) => v.toLocaleString()}>
                          <Label
                            value="Gallons"
                            position="insideLeft"
                            angle={-90}
                            style={{
                              textAnchor: "middle",
                              fontSize: "18px",
                              fontWeight: "600",
                            }}
                          />
                        </YAxis>
                        <Legend />
                        {myData.map((item, index) => {
                          const decodedKey = decodeURIComponent(item);
                          const keyPresent = aggregateData.some(
                            (d) => decodedKey in d
                          );
                          return keyPresent ? (
                            <Line
                              key={index}
                              type="monotone"
                              dataKey={decodedKey}
                              isAnimationActive={false}
                              name={item?.meter}
                              fill={color[index]}
                              stroke={color[index]}
                              strokeWidth={2}
                            />
                          ) : null;
                        })}
                        <CartesianGrid stroke="lightGrey" />
                        <Tooltip formatter={(v) => v.toLocaleString()} />
                      </LineChart>
                    </ResponsiveContainer>
                  ) : (
                    // <div className="chart-placeholder"></div>
                    <div className="example">
                      <Spin size="large" />
                    </div>
                  )}
                </div>
                {/* ))} */}
              </div>
            </div>
          ) : (
            <div className="col-12 col-lg-9 water-chartLists bg-white water-graphs">
              <div className="col-12 pb-5" id="domEl">
                <div className="bg-white pt-4 h-100">
                  {myDatas.map((dataKey, index) => {
                    const chartData = aggregateDatas?.[0]?.[index] || [];
                    // const chartData = chartDataArray[index] || [];

                    return (
                      <div key={`chart_${index}`}>
                        <div className="ml-auto downloads float-right mt-4 me-5">
                          <Dropdown
                            getPopupContainer={(trigger) => trigger.parentNode}
                            menu={{
                              items: [
                                {
                                  label: (
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        downloadImage(dataKey.code, index);
                                      }}
                                    >
                                      Download As PNG
                                    </a>
                                  ),
                                  key: index.toString(),
                                },
                                {
                                  type: "divider",
                                },
                                {
                                  label: (
                                    <button className="csvlink">
                                      <CSVLink
                                        data={listOfUsers[index]}
                                        filename={
                                          dataKey.code.toString() +
                                          "-" +
                                          JSON.parse(
                                            localStorage.getItem("MCData")
                                          )?.selectedDistrict?.toString()
                                        }
                                      >
                                        Download As CSV
                                      </CSVLink>
                                    </button>
                                  ),
                                  key: (index + myDatas.length).toString(),
                                },
                              ],
                            }}
                            trigger={["click"]}
                            className="me-0 px-3"
                          >
                            <a onClick={(e) => e.preventDefault()}>
                              <Space>
                                {/* Download <DownOutlined /> */}
                                <img
                                  src={download}
                                  alt="download"
                                  style={{ width: "25px" }}
                                />
                              </Space>
                            </a>
                          </Dropdown>
                        </div>
                        <div
                          className="line-chart pb-4"
                          ref={(el) => (domEls.current[index] = el)}
                        >
                          <div
                            style={{
                              maxWidth: "100%",
                              margin: "0 auto",
                              height: "500px",
                              paddingTop: "80px",
                              backgroundColor: "white",
                            }}
                          >
                            {Array.isArray(chartData) &&
                            chartData.length > 0 ? (
                              <ResponsiveContainer
                                width="100%"
                                height="100%"
                                key={`chart-${index}-${chartData.length}`}
                              >
                                <LineChart
                                  data={chartData}
                                  margin={{
                                    top: 5,
                                    right: 50,
                                    left: 20,
                                    bottom: 5,
                                  }}
                                >
                                  <XAxis
                                    xAxisId="0"
                                    dataKey="option"
                                    tick={false}
                                    angle={-45}
                                    textAnchor="end"
                                  />
                                  <XAxis
                                    dataKey="code_name"
                                    allowDuplicatedCategory={false}
                                    xAxisId="1"
                                  />
                                  <YAxis
                                    type="number"
                                    tickFormatter={(value) =>
                                      value.toLocaleString()
                                    }
                                  >
                                    <Label
                                      value="Gallons"
                                      position="insideLeft"
                                      angle={-90}
                                      style={{
                                        textAnchor: "middle",
                                        fontSize: "18px",
                                        fontWeight: "600",
                                      }}
                                    />
                                  </YAxis>
                                  <Legend />
                                  {dataKey?.accounts.map((account, i) => (
                                    <Line
                                      key={account}
                                      type="monotone"
                                      dataKey={account}
                                      stroke={color[i]}
                                      activeDot={{ r: 8 }}
                                      fill="#4285F4"
                                      strokeWidth={3}
                                    />
                                  ))}

                                  <CartesianGrid stroke="lightGrey" />
                                  <Tooltip
                                    formatter={(value) =>
                                      value.toLocaleString()
                                    }
                                  />
                                </LineChart>
                              </ResponsiveContainer>
                            ) : (
                              // <div className="chart-placeholder"></div>
                              <div className="example">
                                <Spin size="large" />
                              </div>
                            )}
                          </div>
                          {/*  */}
                          <div className="col-md-12 text-center py-3 bg-white">
                            <div className="d-flex align-items-center justify-content-center">
                              {showInputs[index] ? (
                                <div className="d-flex align-items-center justify-content-center">
                                  <p className="mb-0">
                                    {inputValues[index] !== ""
                                      ? inputValues[index]
                                      : (() => {
                                          const code =
                                            aggregateDatas?.[0]?.[index]?.[0]
                                              ?.code;
                                          switch (code) {
                                            case "PD":
                                              return "Potable Domestic";
                                            case "PF":
                                              return "Potable Fire";
                                            case "PI":
                                              return "Potable Irrigation";
                                            case "NPI":
                                              return "Non-Potable Irrigation";
                                            default:
                                              return "";
                                          }
                                        })()}
                                  </p>

                                  <img
                                    src={edit}
                                    alt="edit"
                                    style={{
                                      width: "25px",
                                      marginLeft: "1rem",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => onClickContent(index)}
                                  />
                                </div>
                              ) : (
                                <div className="d-flex align-items-center justify-content-center">
                                  <input
                                    type="text"
                                    name=""
                                    className="form-control"
                                    onChange={(event) =>
                                      handleInputChange(event, index)
                                    }
                                    style={{
                                      width: "200px",
                                      border: "2px solid #eee",
                                      height: "40px",
                                    }}
                                  />
                                  <div className="d-flex align-items-center justify-content-center ms-4">
                                    <CheckOutlined
                                      onClick={() => onClickValue(index)}
                                      style={{
                                        fontSize: "20px",
                                        padding: "0 15px",
                                        color: "#4285f4",
                                        height: "30px",
                                        marginRight: "15px",
                                        fontWeight: 800,
                                      }}
                                    />
                                    <CloseOutlined
                                      onClick={() => onClickClose(index)}
                                      style={{
                                        fontSize: "20px",
                                        padding: "0 15px",
                                        color: "#ff1800",
                                        height: "30px",
                                        fontWeight: 800,
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          {/*  */}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      </Main>
    </>
  );
}

export default WaterAgg;
